module.exports = __webpack_public_path__ + "img/gallery08.6de95e92.png";